// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-switch[data-v-1698fc15]{display:flex;align-items:center}.front-label[data-v-1698fc15]{margin-right:7px}.x-switch[data-v-1698fc15] .help-button{margin-top:2px}.x-input.v-input--selection-controls[data-v-1698fc15]{margin-top:0;padding-top:0}", ""]);
// Exports
module.exports = exports;
